var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpotlightinactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.65 6.50018L16.91 2.96018L20.84 2.18018L21.62 6.10018L19.65 6.50018ZM16.71 7.07018L13.97 3.54018L12 3.93018L14.75 7.46018L16.71 7.07018ZM4.15996 5.50018L3.17996 5.69018C2.09996 5.90018 1.38996 6.96018 1.60996 8.04018L1.99996 10.0002L6.89996 9.03018L4.15996 5.50018ZM11.81 8.05018L9.06996 4.50018L7.09996 4.91018L9.84996 8.44018L11.81 8.05018ZM3.99996 20.0002V12.0002H20V13.0902C20.72 13.2102 21.39 13.4602 22 13.8102V10.0002H1.99996V20.0002C1.99996 21.1102 2.89996 22.0002 3.99996 22.0002H13.81C13.46 21.3902 13.22 20.7202 13.09 20.0002H3.99996ZM23 17.8902L20.11 17.6402L19 15.0002L17.87 17.6402L15 17.8902L17.18 19.7702L16.5 22.5802L19 21.0902L21.45 22.5802L20.8 19.7702L23 17.8902Z",
    fill: "#8390AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotlightinactive);
export default __webpack_public_path__ + "static/media/Spotlight inactive.f0f4853f4f87453497582727d691ac36.svg";
export { ForwardRef as ReactComponent };